import { Link } from "supercell-frontend-base/src/components/article/navigation/link";

import { getArticleIndex } from "supercell-frontend-base/src/utils/articles/get-article-index";

import { filterEntry } from "supercell-frontend-base/src/targeting/targeting";
import { BrawlStarsGameParams } from "../../validation/game-params";
import { isOnNewsTab } from "supercell-frontend-base/src/utils/articles/is-on-tab";

export const getProps =
    (id: string, isolated: boolean, gameParams: BrawlStarsGameParams) =>
    ({ articles, globals }: { articles: any; globals: any }) => {
        const newsArticles = articles.filter(isOnNewsTab);

        const validArticles = newsArticles.filter((e: any) =>
            filterEntry(e, gameParams),
        );

        const index = getArticleIndex(validArticles, id);
        const article = validArticles[index];

        const nextPrevArticles = validArticles.filter(
            (e: any) => e.showInNewsFeed !== "HIDE_IN_NEWS_FEED",
        );
        const nextPrevArticlesIndex = getArticleIndex(nextPrevArticles, id);
        const prevArticle = nextPrevArticles[nextPrevArticlesIndex - 1];
        const nextArticle =
            nextPrevArticlesIndex > -1 &&
            nextPrevArticles[nextPrevArticlesIndex + 1];

        const prevLinkProps = !isolated
            ? {
                  disabled: !prevArticle,
                  label: globals["globalText.langOlder"],
                  labelComponentProps: {
                      data: prevArticle as any,
                  },
              }
            : undefined;

        const nextLinkProps = !isolated
            ? {
                  next: true,

                  disabled: !nextArticle,
                  label: globals["globalText.langNewer"],
                  labelComponentProps: {
                      data: nextArticle as any,
                  },
              }
            : undefined;

        return {
            article,
            Link,
            prevLinkProps,
            nextLinkProps,
        };
    };
